<template>
    <div class="content">
        <div class="col scrollspy">
          <ul class="nav-subitems">
            <template v-for="item in titles">
              <li :key="item.id" class="scrollactive-item" >
                <a :href="item.id" :key="item.id" v-html="item.title" v-on:click="goToSection"></a>
              </li>
            </template>
          </ul>
        </div>
        <div class="col" id="content" v-html="content">
        </div>
    </div>
</template>

<script>
export default {
  name: 'PageWithScrollSpy',
  data: function () {
    return {
      scrollPos: 0,
      scrollTop: 0
    }
  },
  props: {
    content: {
      type: String,
      required: false,
      default: 'Content goes here'
    },
    titles: {
      required: false,
      default: []
    }
  },
  methods: {
    goToSection (event) {
      event.preventDefault()
      var hash = event.target.hash.substring(1)
      var el = document.getElementById(hash)
      el.scrollIntoView({
        behavior: 'smooth'
      })
      // console.log(event.target.hash)
      return false
    },
    handleScroll (event) {
      const scrollSpy = document.getElementById('scrollspy')
      const scrollSpyBottom = scrollSpy.getBoundingClientRect().bottom
      const scrollSpyHeight = scrollSpy.getBoundingClientRect().height
      const footerTop = document.getElementsByClassName('footer-container')[0].getBoundingClientRect().top

      if (footerTop < scrollSpyBottom) {
        const diff = footerTop - scrollSpyBottom
        scrollSpy.style.top = 100 + diff + 'px'
      } else {
        if (footerTop > 480 + scrollSpyHeight) {
          scrollSpy.style.top = '480px'
        }
      }
    }
  }
}
</script>

<style>
#content .col p {
  margin-left: 0px;
}

.last-text {
    padding-bottom: 250px;
}

.fase-1-row-name {
    padding-left: 20px;
    width: 30%;
    display: inline-block;
    vertical-align: top;
}

.fase-1-row-description {
    padding-left: 10px;
    width: 60%;
    display: inline-block;
}

.fase-number {
    background-color: #262b55;
    color: #fff;
    font-size: 14px;
    padding-left: 10px;
    padding-right: 20px;
    border-radius: 20px;
    display: inline-block;
    margin-top: 0px;
    margin-bottom: 20px;
}

.fase-text {
    margin-left: 20px;
    display: inline-block;
    color: #787878;
    font-size: 20px;
}

.spacer {
    border-bottom: 1px solid #000;
    width: 100%;
    margin-left: -20px;
    margin-top: 40px;
    margin-bottom: 40px;
}

.nav-subitems{
  z-index: 999;
  padding: 30px;
  padding-top: 0px;
  margin-top: 0px;
}

.nav-subitems a {
  display: block;
  color: #000;
  width: 350px;
  word-wrap: break-word;
  text-decoration: none;
}

.nav-subitems .is-active {
  color: #ce5e31;
}

.nav-subitems .is-active:before {
  content: "\2B24";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #ce5e31; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  padding-right: 8px;
  font-size: 16px;
  vertical-align:middle;
  line-height:20px;
}

.sub-content {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin: 0px 0px 0px -20px;
  padding: 0px 0px 0px 0px;
}

.sub-content .col:nth-child(1) {
  flex-basis: 45%;
  flex-grow: 1;
}

.sub-content .col:nth-child(2) {
  flex-basis: 45%;
  flex-grow: 1;
}

.sub-content .col img {
  width: 375px;
  height: auto;
  border-radius: 10px;
}

.text-first {
  margin-left: -20px;
}

.blue-with-corner {
  justify-content: initial;
  order: 2;
  flex-grow: 2;
  background-color: #d0e3f3;
  border-top-left-radius: 80px;
  flex-wrap: wrap;
  height: auto;
  padding-top: 40px;
}

.btn {
  height: 1rem;
  padding: 4px 15px 22px 15px;
}

.call-to-action-btn {
  font-size: 13px;
  background-color: rgba(206, 94, 49, 0.5);
  color: #fff;
  border-radius: 20px;
  width: auto;
}

.content {
  height: auto;
  min-height: 800px;
}

.content ul {
  list-style: none;
  margin-left: 0px;
  padding-left: 0px;
  color: #ce5e31;
  display: table;
}

.content li {
  color: #000;
  font-size: 15px;
  display: table-row;
}

.content li:before {
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #ce5e31; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  padding-right: 8px;
  font-size:50px;
  vertical-align:top;
  line-height:20px;
  display: table-cell;
}

.column-50-percent {
  width: 49%;
  display: inline-block;
  padding-top: 5px;
  margin-top: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.content {
  position: relative;
  display: flex;
  flex-wrap: wrap;
}

.content .col {
  padding-bottom: 20px;
}

.content .col:nth-child(1) {
  padding-right: 0px;
  margin-right: 0px;
}

.video {
  width: 100%;
  max-width: 506px;
}

.call-to-action-btn-content {
  margin-bottom: 0px;
  width: 180px;
  background-color: #efefef;
  border-radius: 10px;
  height: 120px;
  padding-top: 15px;
  color: #000;
  margin-top: 10px;
  margin-right: 30px;
}

.call-to-action-btn-content a {
  color: #000;
}

.call-to-action-btn-content:hover,
.call-to-action-btn-content:hover a {
  background-color: #ce5e31;
  color: #fff;
  text-decoration: none;
  animation: changeBackground .5s linear;
}

.call-to-action-btn-content .training-icon,
.call-to-action-btn-content .trainings-icon {
  font-size: 30px;
}

.call-to-action-btn-content .training-icon-box,
.call-to-action-btn-content .trainings-icon-box {
  height: 50px;
}

@keyframes changeBackground {
  from {background-color: #efefef}
  to {background-color: #ce5e31}
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .last-text {
    padding-bottom: 10px;
  }

  .nav-subitems {
    display: none;
  }

  #content {
    padding-top: 20px;
  }

  .content .scrollspy {
    display: none;
  }

  .content .col {
    flex-basis: calc(100%);
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .sub-content .col-text {
    display: block;
  }

  .sub-content .col-image {
    display: none;
  }

  .fase-1-row-name {
    padding-left: 0px;
  }

  .call-to-action-btn-content {
    width: 95%;
    margin-left: 0px;
    margin-right: 20px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .nav-subitems {
    display: none;
  }

  .content .scrollspy {
    display: none;
  }

  .content .col {
    flex-basis: 375px;
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .sub-content .col-text {
    flex-basis: 100%;
    flex-grow: 1;
  }

  .sub-content .col-image {
    display: none;
  }

  .call-to-action-btn-content {
    width: 95%;
    margin-left: 0px;
    margin-right: 20px;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .content .col:nth-child(2) {
    flex-basis: 100%;
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 10px;
  }

  .content .col:nth-child(0) {
    display: block;
  }

  .sub-content .col {
    display: initial;
  }

  .sub-content .col-text {
    flex-basis: 100%;
    flex-grow: 1;
  }

  .sub-content .col-image {
    display: none;
  }

  .fase-1-row-name {
    padding-left: 20px;
  }

  .call-to-action-btn-content {
    max-width: 180px;
    margin-left: 0px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .last-text {
    padding-bottom: 250px;
  }

  .content .col:nth-child(1) {
    display: block;
    flex-basis: 25%;
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .nav-subitems {
    display: block;
  }

  .sub-content .col-image {
    display: block;
  }

  .content .col:nth-child(2) {
    flex-basis: 66%;
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .sub-content .col:nth-child(1) {
    flex-basis: 45%;
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .sub-content .col:nth-child(2) {
    flex-basis: 45%;
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .content .col:nth-child(1) {
    flex-basis: 30%;
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .content .col:nth-child(2) {
    flex-basis: 60%;
    flex-grow: 2;
    margin-left: 20px;
    margin-right: 10px;
  }

  .content .col:nth-child(2) p {
    width: 95%;
  }

  .sub-content .col:nth-child(1) {
    flex-basis: 45%;
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .sub-content .col:nth-child(2) {
    flex-basis: 45%;
    flex-grow: 1;
    margin-left: 35px;
    margin-right: 10px;
  }

  .call-to-action-btn-content {
    max-width: 150px;
    margin-bottom: 0px;
  }
}
</style>
